module.exports = __webpack_public_path__ + "static/media/doctor.9fc038cb.svg";